var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#BCC3D0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.01246C9.5 4.11226 10.5766 3.66144 11.2062 4.29798L14.3016 7.4273C16.4339 9.58289 17.5 10.6607 17.5 12C17.5 13.3393 16.4339 14.4171 14.3016 16.5727L11.2062 19.702C10.5766 20.3386 9.5 19.8877 9.5 18.9875C9.5 18.7196 9.6053 18.4625 9.79274 18.2731L12.8882 15.1437C13.9942 14.0255 14.6786 13.3276 15.1112 12.7544C15.5016 12.2371 15.5012 12.0565 15.501 12.0028L15.501 12L15.501 11.9973C15.5012 11.9435 15.5016 11.7629 15.1112 11.2456C14.6786 10.6724 13.9942 9.97446 12.8882 8.85627L9.79274 5.72695C9.6053 5.53745 9.5 5.28044 9.5 5.01246Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.19d6aedcb8a1214c3efa6f84e84481fe.svg";
export { ForwardRef as ReactComponent };